import React, { memo } from "react";
import { DeleteIcon } from "@chakra-ui/icons";
import { Box } from "@chakra-ui/layout";
import { HStack, IconButton, SkeletonText, Tooltip } from "@chakra-ui/react";
import { Table, Tbody, Td, Th, Tr, Thead } from "@chakra-ui/table";
import { CherryHubAdminApi } from "../../api/adminApiModels";

interface GeoLocationsTableProps {
  geoLocations: CherryHubAdminApi.GeoLocation[] | null;
  isLoading: boolean;
  disableActions?: boolean;
  onClickGeoLocation: (geoLocation: CherryHubAdminApi.GeoLocation) => void;
  onClickDeleteGeoLocation: (
    geoLocation: CherryHubAdminApi.GeoLocation
  ) => void;
}

export const GeoLocationsTable = memo(
  ({
    geoLocations,
    isLoading,
    disableActions,
    onClickGeoLocation,
    onClickDeleteGeoLocation,
  }: GeoLocationsTableProps) => {
    return (
      <Box w="100%" overflowX="auto">
        <Table size="sm">
          <Thead>
            <Tr>
              <Th>Display Name</Th>
              <Th>Default Location Message</Th>
              <Th>Address</Th>
              <Th></Th>
            </Tr>
          </Thead>
          <Tbody>
            {!isLoading &&
              (geoLocations ?? []).map((geoLocation) => (
                <Tr key={geoLocation.GeoLocationId}>
                  <Td
                    title="View geo location."
                    _hover={{
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                    onClick={() => onClickGeoLocation(geoLocation)}
                  >
                    {geoLocation.DisplayName}
                  </Td>
                  <Td>{geoLocation.RelevantText}</Td>
                  <Td>{geoLocation.Address ?? "-"}</Td>
                  <Td width="0.1%" whiteSpace="nowrap">
                    <HStack spacing={2} justifyContent="center">
                      <Tooltip
                        label={`Delete "${geoLocation.DisplayName}"`}
                        placement="top"
                      >
                        <IconButton
                          aria-label={`Delete "${geoLocation.DisplayName}"`}
                          icon={<DeleteIcon />}
                          size="xs"
                          isDisabled={disableActions}
                          onClick={() => onClickDeleteGeoLocation(geoLocation)}
                        />
                      </Tooltip>
                    </HStack>
                  </Td>
                </Tr>
              ))}
            {geoLocations?.length === 0 && !isLoading && (
              <Tr>
                <Td colSpan={4} textAlign="center">
                  No geo locations found.
                </Td>
              </Tr>
            )}
            {isLoading && (
              <Tr>
                <Td colSpan={4}>
                  <SkeletonText noOfLines={6} spacing="4" width="100%" />
                </Td>
              </Tr>
            )}
          </Tbody>
        </Table>
      </Box>
    );
  }
);
